import * as React from "react";
const SvgFiBrandsCreativeCommonsNcEu = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <g clipPath="url(#fi-brands-creative-commons-nc-eu_svg__a)">
      <path
        fill="#151A2D"
        d="M21.37 3.48Q17.74 0 12.483 0 7.29 0 3.692 3.48-.001 7.08 0 12t3.692 8.459Q7.383 24 12.483 24q5.163 0 8.948-3.57Q25.001 17.04 25 12t-3.63-8.52m-1.565 15.39q-3.097 2.94-7.29 2.939t-7.228-2.91Q2.254 15.989 2.254 12q.002-1.688.551-3.191l3.313 1.408h-.24v1.426H7.05c0 .202-.02.402-.02.603v.342H5.876v1.426h1.36c.189 1.065.608 1.928 1.172 2.612 1.172 1.487 3.056 2.29 5.107 2.29 1.34 0 2.553-.381 3.264-.764l-.503-2.23c-.44.221-1.422.522-2.385.522-1.047 0-2.03-.301-2.7-1.024-.314-.341-.544-.804-.69-1.406h4.549l6.465 2.747a9.4 9.4 0 0 1-1.71 2.109m-8.13-6.283-.027-.02zm3.892-.945h.186v-1.426H12.21l-1.44-.611a2.7 2.7 0 0 1 .443-.694c.649-.764 1.568-1.085 2.574-1.085.92 0 1.778.261 2.322.482l.587-2.29c-.754-.321-1.863-.602-3.139-.602-1.966 0-3.641.763-4.834 2.049a6 6 0 0 0-.703.97L3.91 6.689q.595-.861 1.409-1.65 2.941-2.88 7.197-2.88 4.255 0 7.228 2.88 3.003 2.85 3.003 6.96 0 1.354-.318 2.558z"
      />
    </g>
    <defs>
      <clipPath id="fi-brands-creative-commons-nc-eu_svg__a">
        <path fill="#fff" d="M0 0h25v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsCreativeCommonsNcEu;
